import { FONT_BASE } from 'game/constants/AppFonts';

export class DisplayTimelineProgress extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.width = 573;
    this.height = 74;

    this.x = 840 - this.width / 2;
    this.y = 40;

    this.dotCount = 14;

    this.timeSpacing = 28;
    this.dotSpacing = 19;
    this.dotSpacingFromTime = 19;

    this.timeIndex = this.scene.game._player.currentTimeIndex;
    this.setEndTime();
    this.setCurrentTime();
    this.createDots();
  }

  setCurrentTime() {
    this.timeContainer = this.scene.add.container(this.timeSpacing * this.timeIndex, 0);

    this.time = this.scene.add
      .text(0, 0, `${this.scene.game._player.currentTime.time}`, {
        fontFamily: FONT_BASE.PIXEL_OPERATOR_HB,
        fontSize: 40,
        color: '#A61780',
      })
      .setOrigin(0);

    this.timePrefix = this.scene.add
      .text(0, this.time.height, `${this.scene.game._player.currentTime.prefix.toUpperCase()}`, {
        fontFamily: FONT_BASE.PIXEL_OPERATOR,
        fontSize: 32,
        color: '#A61780',
      })
      .setOrigin(0);

    this.timePrefix.x = this.time.width * 0.5 - this.timePrefix.width * 0.5;

    this.timeline_arrow = this.scene.add.sprite(0, -15, 'ui', 'timeline_arrow').setOrigin(0);

    this.timeline_arrow.x = this.time.width * 0.5 - this.timeline_arrow.width * 0.5;

    this.timeContainer.add([this.timePrefix, this.time, this.timeline_arrow]);
    this.add(this.timeContainer);
  }

  setEndTime() {
    this.endTime = this.scene.add
      .text(this.width, 5, `00:00`, {
        fontFamily: FONT_BASE.PIXEL_OPERATOR,
        fontSize: 33,
        color: '#000000',
      })
      .setOrigin(1, 0);

    this.add(this.endTime);
  }

  createDots() {
    const offset = this.time.width + this.dotSpacingFromTime;

    for (let i = 0; i < this.dotCount; i++) {
      let x = (this.dotSpacing + 9) * i;

      if (i >= this.timeIndex) {
        x += offset;
      }

      const dot = this.scene.add.rectangle(x, 20, 9, 9, '#000000').setOrigin(0);
      this.add(dot);
    }
  }

  shutdown() {
    this.destroy();
  }
}
